import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Aos from 'aos';
//import 'aos/dist/aos.css'; // You can also use <link> for styles
import { Web3ReactProvider } from "@web3-react/core";
import { ethers } from "ethers";
import { Provider } from "react-redux";
import SafeProvider from '@gnosis.pm/safe-apps-react-sdk';
import  {store}  from "./redux/store";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
Aos.init();
const getLibrary = (provider) => {
  const library = new ethers.providers.Web3Provider(provider);
  library.pollingInterval = 12000;
  return library;
};
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <SafeProvider>
        <Web3ReactProvider getLibrary={getLibrary}>
          <App />
        </Web3ReactProvider>
      </SafeProvider>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
